module.exports = __webpack_public_path__ + "img/choujin.8426e7a1.png";